/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._c71l54ef%7Bmax-height%3Acalc(100vh%20-%2075pt)%7D");
import React, { useMemo, useState } from 'react';
import FabricAnalyticsListeners, { FabricChannel } from '@atlaskit/analytics-listeners';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { AppSwitcher } from '@atlaskit/atlassian-navigation';
import Popup from '@atlaskit/popup';
import { useAnalytics } from '@atlassian/ptc-common';
import RemoteSwitcherPlugin from '@atlassian/remote-module-loader/plugin-switcher';
import { RemoteComponent } from '@atlassian/remote-module-loader/remote-component';
import AtlassianSwitcher, { AtlassianSwitcherPrefetchTrigger, SwitchToTooltipText } from '@atlassian/switcher';
import { useSiteStandaloneApp } from '../../../../../../controllers/site-standalone-app';
enum MicrosEnv {
  ADEV = 'adev',
  STG_EAST = 'stg-east',
  PROD_EAST = 'prod-east',
}
const styles = {
  switcherWrapper: "_c71l54ef"
};

// @ts-ignore
const getEnv = (): MicrosEnv | undefined => (window.__env__ as MicrosEnv);
export const remoteSwitcherPlugin: RemoteSwitcherPlugin = new RemoteSwitcherPlugin({
  env: getEnv()?.includes('prod') ? 'production' : 'staging',
  variant: 'latest'
});
type SwitcherComponentProps = React.ComponentProps<typeof AtlassianSwitcher>;
const SwitcherContent = () => {
  const analytics = useAnalytics();
  const [{
    cloudId
  }] = useSiteStandaloneApp();
  const switcherProps = useMemo<SwitcherComponentProps>(() => {
    return {
      cloudId,
      appearance: 'standalone',
      product: 'people'
    };
  }, [cloudId]);
  return <div data-testid="teams-atlassian-switcher" className={ax([styles.switcherWrapper])}>
			<FabricAnalyticsListeners
    // @ts-ignore Analytics web client types mismatch
    client={analytics.getAnalyticsWebClient()} excludedChannels={[FabricChannel.atlaskit, FabricChannel.elements, FabricChannel.editor, FabricChannel.media]}>
				<RemoteComponent<SwitcherComponentProps> remotePlugin={remoteSwitcherPlugin} analyticsChannel="navigation" ErrorFallback={<AtlassianSwitcher {...switcherProps} />}
      // switcher props
      {...switcherProps} />
			</FabricAnalyticsListeners>
		</div>;
};
const AtlassianSwitcherItem = (): JSX.Element => {
  const [{
    cloudId
  }] = useSiteStandaloneApp();
  const [isOpen, setOpen] = useState(false);
  return <Popup placement="bottom-start" content={SwitcherContent} isOpen={isOpen} onClose={() => setOpen(false)} trigger={triggerProps => <AtlassianSwitcherPrefetchTrigger cloudId={cloudId}>
					<AppSwitcher onClick={() => setOpen(isOpen => !isOpen)} tooltip={SwitchToTooltipText} {...triggerProps} />
				</AtlassianSwitcherPrefetchTrigger>} />;
};
export default AtlassianSwitcherItem;